export enum TranslationTypeEnum{
  EMAIL = "EMAIL",
  SMS = "SMS"
}